const colors = {
  border: '#E4E4E7',
  primary: {
    100: '#BED3FF',
    200: '#90B3FE',
    300: '#6293FB',
    400: '#4179F2',
    500: '#306CEE',
    600: '#215CDA',
    700: '#1C4EBA',
    800: '#1440A1',
    900: '#0B348B',
  },
  secondary: {
    400: '#F7F6F2',
    500: '#E3E2DC',
    600: '#CAC9C4',
    700: '#ADACA7',
    800: '#8F8E8A',
    900: '#75746E',
  },
};

export default colors;
